import React, {  useState } from "react";

import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";
import Service from "../../components/Service/service";
import AboutUs from "../../components/AboutUs/AboutUs";
import WebsiteDesc from "../../components/WebsiteDesc/WebsiteDesc";
import Team from "../../components/Team/Team";
import Process from "../../components/Process/Process";
import Testimonials from "../../components/Testimonials/Testimonials";
import GetStart from "../../components/GetStart/GetStart";
import Contact from "../../components/Contact/Contact";
import Footer from "../../components/Footer/footer";

const Index1 = () => {
  const [state] = useState({
    navItems: [
      { id: 1, idnm: "home", navheading: "Inicio" },
      { id: 2, idnm: "services", navheading: "Servicios" },
      { id: 3, idnm: "features", navheading: "Características" },
      { id: 5, idnm: "team", navheading: "Equipo" },
      { id: 7, idnm: "contact", navheading: "Contacto" },
    ],
    navClass: "",
  });

  return (
    <React.Fragment>
      {/* Importing Navbar */}
      <NavbarPage navItems={state.navItems} navClass={state.navClass} />

      {/* section */}
      <Section />

      {/* services */}
      <Service sectionClass="pt-5" />

      {/* about us */}
      <AboutUs />

      {/* website description */}
      <WebsiteDesc />

      {/* team */}
      <Team />

      {/* process */}
      <Process />

      {/* testimonial */}
      <Testimonials />

      {/* get started */}
      <GetStart />

      {/* contact */}
      <Contact />

      {/* footer */}
      <Footer />
    </React.Fragment>
  );
};

export default Index1;
